module.exports = __webpack_public_path__ + "img/05_kudo_08.31419681.jpg";